import React, { Component } from "react";
//import cookie from "react-cookies";
import Button from "@material-ui/core/Button";
import OnlineBolt from "@material-ui/icons/Translate";
import IconButton from "@material-ui/core/IconButton";

import { googleTranslate } from "../shared/TranslatorKey";

class GoogleTranslateAPI extends Component {
  state = {
    languageCodes: [],
    language: "en",
    question: "how will I know if he is there"
  };

  componentDidMount() {
    // load all of the language options from Google Translate to your app state

    googleTranslate.getSupportedLanguages("en", function(err, languageCodes) {
      getLanguageCodes(languageCodes); // use a callback function to setState
    });

    const getLanguageCodes = languageCodes => {
      this.setState({ languageCodes });
    };
  }

  render() {
    const { languageCodes, language, question } = this.state;

    return (
      <div className="div-iline">
        {/* <div style={this.divStyle}> */}
        {/* <p>{question}</p>

        <select
          className="select-language"
          value={language}
          onChange={e => this.changeHandler(e.target.value)}
        >
          {languageCodes.map(lang => (
            <option key={lang.language} value={lang.language}>
              {lang.name}
            </option>
          ))}
        </select> */}

        <IconButton
          aria-label="Share"
          onClick={() => this.ScrapGoogleAPI_ALL()}
        >
          <OnlineBolt />
        </IconButton>

        {/* </div> */}
      </div>
    );
  }

  ScrapGoogleAPI_ALL = () => {
    //PROBLEM KAD JE THIS OBJEKT UNDEFINED u ASYNCU SE RIJEŠAVA SA KREIRANJEM CONST FUNKCIJE
    const translating = (translation_text, language) => {
      this.props.ScrapGoogleAPI(translation_text, language, this.props.type);
    };

    const ScrapGoogleAPI = language => {
      let translation_text = "";
      googleTranslate.translate(this.props.SearchedWord, this.props.Language, language, function(
        err,
        translation
      ) {
        translation_text = translation.translatedText;
        translating(translation_text, language);
        // this.props.ScrapGoogleAPI(translation_text, language);
      });
    };
if(this.props.Spanish.length<1){   ScrapGoogleAPI("es");}
if(this.props.German.length<1){   ScrapGoogleAPI("de");}
if(this.props.English.length<1){   ScrapGoogleAPI("en");}
if(this.props.French.length<1){   ScrapGoogleAPI("fr");}
if(this.props.Italian.length<1){   ScrapGoogleAPI("it");}
    // ScrapGoogleAPI("de");
    // ScrapGoogleAPI("fr");
  };

  // just some inline css to center our demo
  divStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100wh"
  };
}

export default GoogleTranslateAPI;
